import page from 'page-common';

export const isDmsAuthenticationShouldBeBlocked = false;

export const showDmsAuthenticationBlockedStub = () => {
	page.notifications.push({
		css: { 'notification-success': true },
		template: {
			/* eslint-disable max-len */
			html: `<div>
				<p>Уважаемые клиенты!</p>
				<p>
				<br />
					В настоящий момент мы работаем над усовершенствованием сервиса, который будет доступен уже совсем скоро.
					<br />
					Пожалуйста, попробуйте позднее. Сожалеем о доставленных неудобствах.
					<br />
					<p>По вопросам организации медицинской помощи и согласования услуг, пожалуйста, обращайтесь по телефону - <a href="tel:88002005111">8 (800) 200-51-11</a>.</p>
					<br />
				</p>
			</div>`,
			/* eslint-enable max-len */
		}
	});
};